// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import media from 'assets/styles/query';
import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export const Hero = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  grid-template-rows: repeat(2, 2fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;

    grid-area: 1 / 1 / 2 / 2;

    &:nth-child(2) {
      grid-area: 2 / 1 / 3 / 2;
    }

    &:nth-child(3) {
      grid-area: 1 / 2 / 3 / 3;
    }
  }

  ${media.lessThan('small')`
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);

    img {
      grid-area: 3 / 1 / 4 / 2;

      &:nth-child(2) {
        grid-area: 2 / 1 / 3 / 2;
      }

      &:nth-child(3) {
        grid-area: 1 / 1 / 2 / 2;
      }
    }
  `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 2fr;
  grid-template-rows: repeat(2, 2fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;

  position: relative;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;

    grid-area: 1 / 1 / 3 / 2;

    &:nth-child(1) {
      grid-area: 1 / 2 / 3 / 3;
    }
  }

  ${media.lessThan('small')`
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr);

    img {
      grid-area: 2 / 1 / 3 / 2;


      &:nth-child(1) {
        grid-area: 1 / 1 / 2 / 2;
      }
    }
  `}
`;

export const Footer = styled.footer`
  position: absolute;
  bottom: 0px;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -2px;

  width: 100%;
  height: 15vh;

  background: rgba(136, 148, 195, 0.2);
  backdrop-filter: blur(12.5px);
`;

export const StyledButton = styled.button`
  border-radius: 12px;
  border: 2px solid #fff;
  background-color: transparent;
  padding: 4px 24px;
  transition: 0.3s ease-in-out;

  color: #fff;
  font-family: 'SF Pro Display';
  font-size: 18.087px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.362px;

  &:hover {
    background-color: #fff;
    color: #000;
  }

  &:active {
    transform: scale(0.98);
  }
`;
